import styled from 'styled-components/macro'
import React, { useEffect, useState, useRef} from 'react'
import {AiOutlineLeft, AiOutlineRight} from 'react-icons/ai'
import {AiOutlineLink} from 'react-icons/ai'
import {Link} from 'react-router-dom'
import { TypeAnimation } from 'react-type-animation';

const HeroSection = styled.section`
    height: 90vh;
    width: 100vw;
    max-height: 1100px;
    position: relative;
    margin-bottom: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 1324px){
        margin-top: 6rem;
        margin-bottom: 9rem;
        height: 50vh;
    }
    @media screen and (max-width: 924px){
        height: 30vh;
    }
`

const HeroWrapper = styled.div`
    width: 60vw;
    height: 83%;
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    @media screen and (max-width: 1324px){
        width: 80vw;
        height: 70vh;
    }
    @media screen and (max-width: 924px){
        width: 80vw;
        height: 60vw;
    }
`

const HeroSlide = styled.div`
    z-index: 1;
    width: 100%;
    height: 100%;
`

const HeroSlider = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before { 
        content: '';
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100vh;
        bottom: 0vh; 
        left: 0;
        overflow: hidden;
        opacity: 0.4;
    }
`

const PrevArrow = styled(AiOutlineLeft)`
`

const NextArrow = styled(AiOutlineRight)`
`
const Arrow = styled(AiOutlineLink)`
`

const Dots = styled.div`
    position: absolute;
    bottom: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    @media screen and (max-width: 924px){
        bottom: 2rem;
    }

`

const Dot = styled.span`
    cursor: pointer;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: ${({active}) => active ? '#edeceb' : '#6b6b6b'};
    margin: 0 5px;

    @media screen and (max-width: 924px){
        height: 6px;
        width: 6px;
    }
`

const Hero = ({slides}) => {
    const[current, setCurrent] = useState(0)
    const length = slides.length
    const timeout = useRef(null)

    useEffect(() => {
        const nextSlide = () => {
            setCurrent(current => (current === length - 1 ? 0 : current + 1))
        }

        timeout.current = setTimeout(nextSlide, 3000)

        return function(){
            if(timeout.current){
                clearTimeout(timeout.current)
            }
        }
    }, [current, length])

    const nextSlide = () => {
        if(timeout.current){
            clearTimeout(timeout.current)
        }
        setCurrent(current === length - 1 ? 0 : current + 1)
    }

    const prevSlide = () => {
        if(timeout.current){
            clearTimeout(timeout.current)
        }
        setCurrent(current === 0 ? length - 1 : current - 1)
    }

    const handleDotClick = (index) => {
        if(timeout.current){
            clearTimeout(timeout.current)
        }
        setCurrent(index)
    }

    if(!Array.isArray(slides) || slides.length <= 0){
        return null
    }

    return (
        <HeroSection>
            <HeroWrapper >
                {slides.map((slide, index) => {
                    return(
                        <HeroSlide key={index}>
                            {index === current && (
                                <HeroSlider>
                                    <Link to={slide.link} target='_blank' className='btn-key-link'><Arrow/></Link>  
                                    <img src={slide.image} alt={slide.alt} loading="lazy" className={index === current ? 'keyart active' : 'keyart'}/>
                                    <div className='stats'>
                                        <p className='p1'>{slide.ratings}</p>
                                        <div className='stars'>
                                            <p className='p2'>{slide.blank_stars}</p>
                                            <TypeAnimation
                                                sequence={[slide.filled_stars]}
                                                style={{width: slide.stars}}
                                                cursor={false}
                                                speed={1}
                                                className='p3'
                                                wrapper='p'/>
                                        </div>
                                    </div>
                                </HeroSlider>
                            )}
                        </HeroSlide>
                    )
                })}
            </HeroWrapper>
            <PrevArrow className='left-arrow HeroArrow' onClick={prevSlide}/>
                <NextArrow className='right-arrow HeroArrow' onClick={nextSlide}/>
                <Dots>
                    {slides.map((_, index) => (
                        <Dot key={index} active={index === current} onClick={() => handleDotClick(index)} />
                    ))}
                </Dots>
        </HeroSection>
    )
}

export default Hero